import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'animate.css'
import '@harea/component/dist/main.css'
import '@harea/component/dist/index.css'
import '@harea/login/dist/main.css'
import '@harea/translation/dist/main.css'
import '@harea/wizard/dist/main.css'
import '@harea/wizard-node/dist/main.css'
import '@harea/user-management/dist/main.css'
// import '@harea/document-template/dist/main.css'
import '@harea/static-page/dist/main.css'
import './index.css';

createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
